import React, { useCallback } from 'react'
import { DataSeries } from './ChartContent'
import { Circle, LegendCircleContainer, LegendContainer, LegendItemContainer, LegendSpan, LegendSubItemContainer } from './styles'

interface ChartLegendProps {
	dataSeries: DataSeries[]
	visibilityList: Map<string, boolean>
	setVisibilityList: React.Dispatch<React.SetStateAction<Map<string, boolean>>>
	highlightedSeries?: string | null
	setHighlightedSeries?: React.Dispatch<React.SetStateAction<string | null>>
}

const ChartLegend: React.FC<ChartLegendProps> = ({ dataSeries, visibilityList, setVisibilityList, highlightedSeries, setHighlightedSeries }) => {
	const handleToggle = useCallback(
		(ds: DataSeries) => {
			setVisibilityList((prev) => {
				const next = new Map(prev)
				next.set(ds.name, !(next.get(ds.name) ?? true))
				return next
			})
		},
		[setVisibilityList]
	)

	return (
		<LegendContainer>
			{dataSeries.map((ds) => {
				const isVisible = visibilityList.get(ds.name) ?? true
				const isHighlighted = highlightedSeries === ds.name

				return (
					<LegendItemContainer
						key={ds.name}
						onClick={() => handleToggle(ds)}
						onMouseEnter={() => setHighlightedSeries?.(ds.name)}
						onMouseLeave={() => setHighlightedSeries?.(null)}
						role="button"
						tabIndex={0}
						onKeyDown={(e) => {
							if (e.key === 'Enter' || e.key === ' ') {
								e.preventDefault()
								handleToggle(ds)
							}
						}}
						style={{
							opacity: isVisible ? 1 : 0.4,
							cursor: 'pointer',
							userSelect: 'none',
							background: isHighlighted ? 'rgba(255,255,255,0.08)' : undefined
						}}
						title={isVisible ? 'Click to hide series' : 'Click to show series'}
					>
						<LegendCircleContainer>
							<Circle
								style={{
									backgroundColor: ds.color,
									opacity: isVisible ? 1 : 0.5,
									transform: isHighlighted ? 'scale(1.2)' : 'scale(1)',
									transition: 'transform 0.15s ease'
								}}
							/>
						</LegendCircleContainer>
						<LegendSubItemContainer>
							<LegendSpan
								style={{
									textDecoration: isVisible ? 'none' : 'line-through',
									fontWeight: isHighlighted ? 600 : 500
								}}
							>
								{ds.name}
							</LegendSpan>
						</LegendSubItemContainer>
					</LegendItemContainer>
				)
			})}
		</LegendContainer>
	)
}

export default React.memo(ChartLegend)
